import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: theme.spacing(2),
  minHeight: '60vh',
  padding: theme.spacing(4),
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const Description = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.secondary,
  maxWidth: 420,
}));

export const Details = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontFamily: 'monospace',
  color: theme.palette.error.main,
  wordBreak: 'break-word',
  maxWidth: 480,
}));

export const Actions = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(1),
}));
